import { forwardRef, HTMLAttributes, ReactNode } from "react";
import * as SC from "./main.styles";

export interface ContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export interface MainProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Main = forwardRef<HTMLDivElement, MainProps>(
  ({ children, className, style, ...props }, ref) => (
    <SC.Wrapper ref={ref} className={className} style={style} {...props}>
      {children}
    </SC.Wrapper>
  )
);

Main.displayName = "Focused.Main";
